var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82558 4.3125C4.28787 4.3125 3.85046 4.80313 3.85046 5.40688C3.85046 6.01 4.28787 6.5 4.82558 6.5C5.36328 6.5 5.80069 6.01 5.80069 5.40688C5.80069 4.80313 5.36328 4.3125 4.82558 4.3125ZM4.82558 7.4375C3.82706 7.4375 3.01465 6.52688 3.01465 5.40688C3.01465 4.28625 3.82706 3.375 4.82558 3.375C5.8241 3.375 6.63651 4.28625 6.63651 5.40688C6.63651 6.52688 5.8241 7.4375 4.82558 7.4375Z",
    fill: "#06262D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1831_23713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.228516 0.25H9.42218V12.4375H0.228516V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1831_23713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82549 1.1875C2.75156 1.1875 1.06433 3.09812 1.06433 5.44563C1.06433 8.4325 4.19807 11.3425 4.82549 11.4975C5.45291 11.3419 8.58665 8.43188 8.58665 5.44563C8.58665 3.09812 6.89942 1.1875 4.82549 1.1875ZM4.82549 12.4375C3.82586 12.4375 0.228516 8.9675 0.228516 5.44562C0.228516 2.58062 2.29075 0.25 4.82549 0.25C7.36023 0.25 9.42246 2.58062 9.42246 5.44562C9.42246 8.9675 5.82512 12.4375 4.82549 12.4375Z",
    fill: "#06262D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.1c5cbf664e051a1e281e992fc0438c94.svg";
export { ForwardRef as ReactComponent };